import { createSelector } from 'reselect';

const selectLMSCertifiedUsers = (state: any) => state.lmsCertifiedUsers;

export const selectLMSCertifiedUsersCurrentItem = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.current
);

export const selectLMSCertifiedUsersListItems = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.list
);

export const selectLMSCertifiedUsersItemById = (itemId: any) =>
  createSelector(selectLMSCertifiedUsersListItems, (list) =>
    list.result.items.find((item: any) => item._id === itemId)
  );

export const selectLMSCertifiedUsersQueryItems = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.query
);

export const selectLMSCertifiedUsersCreatedItem = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.create
);

export const selectLMSCertifiedUsersUpdatedItem = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.update
);

export const selectLMSCertifiedUsersReadItem = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.read
);

export const selectLMSCertifiedUsersDeletedItem = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.delete
);

export const selectLMSCertifiedUsersSearchedItems = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.search
);

export const selectLMSCertifiedUsersItemsCount = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.count
);

export const selectLMSCertifiedUsersItemsFilter = createSelector(
  [selectLMSCertifiedUsers],
  (lmsCertifiedUsers) => lmsCertifiedUsers.filter
);
